import * as types from '../actions/types'
import { validatePassword } from '../../utils/validations'

const initState = {
  value: '',
  isValid: false,
  validationMessages: [],
}

const password = (state = initState, action) => {
  switch (action.type) {
    case types.UPDATE_CUSTOMER_LOGIN_PASSWORD_FIELD:
      return validatePassword(action.password)
    case types.RESET_FORM_FEILDS:
      return initState
    default:
      return state
  }
}

export default password
